import fetchPlatforms from "../../platforms";

export default {
  setAvailable: available => ({ available, _suppressRenderWarning: true }),
  fetch: () => async (state, actions) => {
    return fetchPlatforms().then(available => {
      actions.setAvailable(available);
      return available;
    });
  }
};
